import { combineReducers } from 'redux';
import {
    CLEAR_REDIRECT,
    LOAD_CONTENT_SUCCESS,
    ADD_REGISTER_PENDING,
    ADD_REGISTER_SUCCESS,
    ADD_REGISTER_FAILURE,
    LOAD_REQUESTS_PENDING,
    LOAD_REQUESTS_COMPLETE,
    LOAD_INSPECTIONS_SUCCESS,
    LOAD_INSPECTIONS_LIST_SUCCESS,
    LOAD_ORGS_COMPLETE,
    LOAD_USERS_COMPLETE,
    FETCH_FAILURE,
    LOAD_INSPECTIONS_PENDING,
    ADD_ORG_AND_USER_PENDING,
    ADD_ORG_AND_USER_COMPLETE,
    ADD_BO_COMPLETE,
    ADD_BO_PENDING,
    GET_BOS_PENDING,
    GET_BOS_COMPLETE,
    GET_COS_PENDING,
    GET_COS_COMPLETE,
    LOGIN_PENDING,
    LOGIN_COMPLETE,
    LOGIN_WITH_EDS_PENDING,
    LOGIN_WITH_EDS_COMPLETE,
    LOAD_NOTIFICATIONS_COMPLETE,
    LOAD_NOTIFICATIONS_PENDING,

    NEW_NOTIFICATION_PENDING,
    NEW_NOTIFICATION_COMPLETE,

    FILE_UPLOAD_COMPLETE,
    
    REMOVE_UNSET_FILE_COMPLETE,
    REMOVE_UNSET_FILE_PENDING,

    SET_NOTIFICATION_SIGNED_COMPLETE,
    GET_NOTIFICATION_COMPLETE,
    SAVE_NOTIFICATION_COMPLETE,
    SET_NOTIFICATION_APPROVED_COMPLETE,
    SET_NOTIFICATION_DECLINED_COMPLETE,
    SEARCH_CONCLUSION_COMPLETE,
    SEARCH_CONCLUSIONS_COMPLETE,
    
    SUBMIT_APPEAL_COMPLETE,
    SUBMIT_APPEAL_FAILED,

    SUBMIT_REPLY_COMPLETE,
    SUBMIT_REPLY_FAILED,

    GET_REPLY_COMPLETE,
    LOAD_APPEALS_COMPLETE,
    SUBMIT_INGOING_NUMBER_COMPLETE,
    LOGOUT,
    ORG_ADD_USER_COMPLETE,
    LOAD_ORG_USERS_COMPLETE,
    UPDATE_ORG_COMPLETE,
    LOAD_ORG_COMPLETE,
    LOAD_SELF_COMPLETE,
    UPDATE_SELF_COMPLETE,
    UPDATE_SELF_FAILED,
    LOAD_BO_COMPLETE,

    CREATE_USER_COMPLETE,
    LOAD_USER_COMPLETE,
    UPDATE_USER_COMPLETE,
    DELETE_NOTIFICATION_SUCCESS,
    DELETE_NOTIFICATION_FAILED,
    DELETE_REGISTRATION_COMPLETE,
    DELETE_REGISTRATION_FAILED,
    GET_PREVIEW_COMPLETE,
    GET_TOTAL_PREVIEW_COMPLETE,
    DELETE_ORG_COMPLETE,
    DELETE_ORG_FAILED,
    ACTIVATE_ORG_COMPLETE,
    ACTIVATE_ORG_FAILED,
    ACTIVATE_ORG_USER,
    DELETE_ORG_USER,
    ACTIVATE_USER_FAILED,
    DELETE_USER_FAILED,
    PREVIEW_IS_LOADING,

    ADD_ATTACHMENT_COMPLETE,
    GET_ATTACHMENTS_COMPLETE,
    REMOVE_ATTACHMENT_COMPLETE
    

} from './../actions/actions';


function register(state = [], action){
    switch (action.type) {
        case ADD_REGISTER_PENDING:
        case ADD_REGISTER_SUCCESS:
            console.log(action);
            return  {...state, status: 'completed', message: action.message, fetching: action.fetching}
        case ADD_REGISTER_FAILURE:
            return  {...state, status: 'error', message: action.message, fetching: action.fetching}
        default:
            return state
    }
}

function user(state = [], action) {
    switch (action.type) {
        case LOGOUT: return {...state, status: 'new', data:null}
        case ORG_ADD_USER_COMPLETE:
            return {...state, status: 'complete', message: action.message,  items: action.items}
        case LOAD_ORG_COMPLETE:
            return {...state, org: action.org}
        case UPDATE_ORG_COMPLETE:
            return {...state, org: action.org, message: action.message}
        case LOAD_ORG_USERS_COMPLETE:
            return {...state, items: action.items, status:'complete',message: action.message}
        case UPDATE_SELF_COMPLETE:
            return {...state, message: action.message, item: action.item}
        case UPDATE_SELF_FAILED:
            return {...state, message: action.message}
        case LOAD_SELF_COMPLETE:
            return {...state, item: action.item}
        case FETCH_FAILURE:
            return {...state, message: action.message}
        case CREATE_USER_COMPLETE:
            return {...state, message: action.message, item: {}, data: action.item}
        case LOAD_USER_COMPLETE:
            return {...state, user: action.item}
        case UPDATE_USER_COMPLETE:
            return {...state, message: action.message, user: action.item}
        case LOGIN_PENDING :
        case LOGIN_COMPLETE : return  {...state, status: 'completed', message: action.message, data: action.data}
        case LOGIN_WITH_EDS_PENDING :
        case LOGIN_WITH_EDS_COMPLETE :  return  {...state, status: 'completed', message: action.message, data: action.data}
        default:
            return state;    
    }      
}

function admin(state = [], action) {
    switch (action.type) {
        case LOAD_REQUESTS_PENDING:
            return {...state, requestsPending: true}
        case LOAD_REQUESTS_COMPLETE:
            return {...state, requests: action.data, requestsPending: false}
        case DELETE_REGISTRATION_COMPLETE:
            return {...state, message: action.message, requests: action.items }
        case DELETE_REGISTRATION_FAILED:
            return {...state, message: action.message}
        case LOAD_INSPECTIONS_PENDING:
            return {...state, inspectionsPending: true}
        case LOAD_INSPECTIONS_SUCCESS:
            return {...state,  inspections: action.data, inspectionsPending: false }
        case LOAD_ORGS_COMPLETE:
            return {...state, orgs: action.data }
        case LOAD_USERS_COMPLETE:
            return {...state, users: action.data }
        case ADD_ORG_AND_USER_COMPLETE:
            return {...state, message: action.message }
        case ADD_BO_PENDING:
            return {...state, message: action.message }
        case ADD_BO_COMPLETE:
            return {...state, message: action.message }
        case DELETE_ORG_COMPLETE:
            return {...state, status: action.status, message: action.message, orgs: action.items}
        case DELETE_ORG_FAILED:
            return {...state, status: action.status, message: action.message}
        case ACTIVATE_ORG_COMPLETE:
            return {...state, status: action.status, message: action.message, orgs: action.items}
        case ACTIVATE_ORG_FAILED:
            return {...state, status: action.status, message: action.message}
        case DELETE_ORG_USER:
            return {...state, status: action.status, message: action.message, users: action.items}
        case DELETE_USER_FAILED:
            return {...state, status: action.status, message: action.message}
        case ACTIVATE_ORG_USER:
            return {...state, status: action.status, message: action.message, users: action.items}
        case ACTIVATE_USER_FAILED:
            return {...state, status: action.status, message: action.message}
        default:
            return state;
    }
}

function notifications(state = [], action) {
    switch (action.type) {
        case FILE_UPLOAD_COMPLETE:
            return {...state, file_data: action.data, url: action.url, open: true}
        case NEW_NOTIFICATION_PENDING:
        case NEW_NOTIFICATION_COMPLETE:
            return {...state, data: [...state.data, action.data], item: action.data, redirect: action.redirect}
        case CLEAR_REDIRECT:
            return {...state, redirect: null}
        case DELETE_NOTIFICATION_SUCCESS:
            return {...state, message: action.message, redirect: 'org-cabinet/'}
        case DELETE_NOTIFICATION_FAILED:
            return {...state, message: action.message, redirect: null}
        case LOAD_NOTIFICATIONS_PENDING:
        case LOAD_NOTIFICATIONS_COMPLETE:
            return {...state, data: action.data}
        case REMOVE_UNSET_FILE_COMPLETE:
            return {...state, open:false}
        case GET_NOTIFICATION_COMPLETE: 
            return {...state, status: action.status, item: action.item }
        case SET_NOTIFICATION_SIGNED_COMPLETE:
            return {...state, status: action.status, open: false, disabled: true}
        case LOAD_INSPECTIONS_LIST_SUCCESS:
            return {...state, inspections: action.data, redirect:null}
        case SAVE_NOTIFICATION_COMPLETE:
            return {...state, item: action.item, message: action.message }
        case SET_NOTIFICATION_DECLINED_COMPLETE:
            return {...state, item: action.item, reply: action.reply}
        case SET_NOTIFICATION_APPROVED_COMPLETE:
            return {...state, item: action.item, reply: action.reply, bo: action.bo}
        case SEARCH_CONCLUSION_COMPLETE:
            return {...state, conclusions: action.conclusions}
        case SEARCH_CONCLUSIONS_COMPLETE:
            return {...state, conclusions: action.conclusions}
        case FETCH_FAILURE:
            return { ...state, message: action.message}
        case ADD_ATTACHMENT_COMPLETE:
            return {...state, message : action.message, attachments: action.items, fileUploadOpen: false}
        case REMOVE_ATTACHMENT_COMPLETE:
            return {...state, message : action.message, attachments: action.items}
        case  GET_ATTACHMENTS_COMPLETE:
            return {...state, message : action.message, attachments: action.items}
        default:
            return state;
    }
}

function inspector(state = [], action) {
    switch (action.type) {
        case SUBMIT_REPLY_COMPLETE:
            return {...state, item: action.reply, notification: action.notification}
        case GET_NOTIFICATION_COMPLETE:
            return {...state,  notification: action.item}
        case GET_REPLY_COMPLETE:
            return {...state,  item: action.item}
        case SEARCH_CONCLUSION_COMPLETE:
            return {...state, conclusions: action.conclusions}
        case LOAD_APPEALS_COMPLETE:
            return {...state, appeals: action.appeals}
        case SUBMIT_INGOING_NUMBER_COMPLETE:
            return {...state, notification: action.item}
        default:
            return state;
    }

}

function bo(state = [], action) {
    switch (action.type) {
        case LOAD_BO_COMPLETE:
            return {...state, item: action.item, message: action.message}
        case GET_BOS_PENDING:
            return {...state, objectsFetching: action.objectsPending}
        case GET_BOS_COMPLETE:
            return {...state, bo:action.data, page: action.page, total: action.total}
        case GET_PREVIEW_COMPLETE:
            console.log('GET_PREVIEW_COMPLETE :', action);
            return {...state, preview_total_loaded: true, preview: action.data}
        case GET_TOTAL_PREVIEW_COMPLETE:
            return {...state, preview_total_loaded: true, preview_total: action.total}
        case PREVIEW_IS_LOADING: 
            return {...state, preview_is_loading: action.payload}
        default:
            return state;
    }
}

function co(state = [], action) {
    switch (action.type) {
        case GET_COS_PENDING:
            return {...state, objectsFetching: action.objectsPending}
        case GET_COS_COMPLETE:
            return {...state, co:action.data, page: action.page, total: action.total}
        default:
            return state;
    }
}

function appeal(state = [], action) {
    switch (action.type) {
        case LOAD_INSPECTIONS_SUCCESS:
            return {...state, inspections: action.data, redirect:null}
        case SUBMIT_APPEAL_COMPLETE:
            return {...state, status: action.status}
        case SUBMIT_APPEAL_FAILED:
            return {...state, status:action.status, message: action.message, errors: action.errors}
        default:
            return state;
    }
}

const rootReducer = combineReducers({register, admin, bo, user, notifications, appeal, inspector, co})

export default rootReducer


// WEBPACK FOOTER //
// ./assets/src/js/reducers/reducers.js